import { makeStyles, tokens } from '@fluentui/react-components';

export const useCircularProgressStyles = makeStyles({
  base: {
    width: '100%',
    aspectRatio: '1',
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  svg: {
    width: '100%',
    height: '100%',
    transform: 'rotate(-90deg)',
    pointerEvents: 'none',
  },
  backgroundCircle: {
    transition: 'stroke 0.3s ease, stroke-dashoffset 0.3s ease',
  },
  progressCircle: {
    transition: 'stroke 0.3s ease, stroke-dashoffset 0.3s ease',
  },
  content: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

  },
  contentText: {
    fontWeight: tokens.fontWeightSemibold,
  },
});
